export interface SearchFilters {
  searchTerm: string;
  location: {
    pays?: string;
    ville?: string;
  };
  metier?: string;
  entreprise?: string;
  sortBy: 'alpha' | 'date' | 'views';
  viewMode: 'grid' | 'list';
}

export interface ProfileSearchProps {
  filters: SearchFilters;
  onFiltersChange: (filters: SearchFilters) => void;
}

export const defaultFilters: SearchFilters = {
  searchTerm: '',
  location: {},
  sortBy: 'date',
  viewMode: 'grid'
};
